// extracted by mini-css-extract-plugin
module.exports = {"input":"input_input__cMBI-","fullWidth":"input_fullWidth__UQyHI"};